import common, { simulator as simulatorApi } from "@/modules/common/api";
import { SOURCE } from "@/modules/julho_14/settings";
import http from "@/utils/http";

export default {
    reservoir: {
        getData(startDate, endDate) {
            return common.getReservoirInfos(SOURCE, startDate, endDate);
        }
    },
    simulator: {
        getData() {
            return http.get("/api/14-julho/simulator/detail/");
        },
        postData(data) {
            return http.post("/api/14-julho/simulator/update/", data);
        },
        simulate() {
            return simulatorApi.start(SOURCE);
        },
        stopSimulation() {
            return simulatorApi.stop(SOURCE);
        },
        getStatus() {
            return simulatorApi.getStatus(SOURCE);
        }
    },
    triaxialJoints: {
        list() {
            return http.get("/api/14-julho/triaxial-joints/");
        },
        results(startDate, endDate) {
            return http.get("/api/14-julho/triaxial-joints/results/", {
                params: {
                    start_date: startDate,
                    end_date: endDate
                }
            });
        },
        readings(startDate, endDate) {
            return http.get("/api/14-julho/triaxial-joints/readings/", {
                params: {
                    start_date: startDate,
                    end_date: endDate
                }
            });
        }
    },
    concreteTemperatureThermometers: {
        list() {
            return http.get("/api/14-julho/concrete-temperature-thermometers/");
        },
        readings(startDate, endDate) {
            return http.get(
                "/api/14-julho/concrete-temperature-thermometers/readings/",
                {
                    params: {
                        start_date: startDate,
                        end_date: endDate
                    }
                }
            );
        },
        readingsByEpoch(epoch: string) {
            return http.get(
                "/api/14-julho/concrete-temperature-thermometers/readings/epoch/",
                {
                    params: {
                        epoch
                    }
                }
            );
        }
    }
};
